const ConvertToNumberDirective = function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel: ng.INgModelController) {
            ngModel.$parsers.push(function (val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function (val) {
                return '' + val;
            });
        }
    };
};

export { ConvertToNumberDirective };